import {
    Decoder,
    field,
    number,
    object,
    string
} from 'json-bouncer'

export interface Manufacturer {
    readonly id: number
    readonly name: string
}

export function manufacturerDecoder(): Decoder<Manufacturer> {
    return object({
        id: field('id', number()),
        name: field('name', string()),
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Manufacturer.entity.evolve.ts